<header class="app-header">

  <!-- Links: Logo + Schriftzug zusammen → Dashboard -->
  <a routerLink="/dashboard" class="header-brand">
    <svg class="header-logo" viewBox="180 -20 440 620" aria-hidden="true">
      <rect fill="#A1C738" x="200.07" y="100.97" width="396.85" height="396.85"/>
      <path fill="#DB9C24" d="M389.01,0c-125.57,122.88-195.85,293.92-192.82,469.27.72,41.78,5.81,83.92,10.7,119.63l2.88-8.43-.08-.71c-.9-8.41-1.82-17.06-2.93-25.62-.09-1.15-.18-2.3-.27-3.45-.38-4.96-.7-9.93-.96-14.9-.68-12.93-.97-26.15-.85-39.29.24-25.59,2.02-51.38,5.29-76.65,7.67-59.24,23.63-116.96,47.41-171.55,32.86-75.43,79.68-143.17,139.14-201.36.6-.59,3.49-3.46,3.49-3.46L389.01,0Z"/>
      <path fill="#fff" d="M484.4,286.87c0-.05-.01-.1-.02-.15-.05-.63-.08-1.26-.14-1.88-.22-2.42-2.95-27.63-3.22-27.6-64.75,7.17-134.54,31.3-184.92,73.06-40.32,33.42-68.26,82.6-90.05,130.14-.78,12.02-1.25,24.06-1.36,36.07h1.24c22.3-49.89,51.04-102.66,93.55-137.9,49.71-41.2,118.32-65.21,182.34-72.73-4.01,91.01-67.69,169.13-151.27,208.73l-4.89,1.9h55.46c30.97-22.15,57.61-50.17,76.79-83.35,22.15-38.32,30.1-83.65,26.48-127.6z"/>
      <path fill="#C8DC83" d="M209.98,419.86c-1.74,13.41-3.03,26.97-3.92,40.56,5.5-11.99,11.39-24.09,17.77-36.01,62.78-141.79,175.94-257.74,317.34-323.44h-59.59c-122.88,72.79-219.2,185.45-271.6,318.89z"/>
    </svg>
    <span class="header-wordmark">
      <span class="wordmark-wendler">WENDLER</span><span class="wordmark-os">OS</span>
    </span>
  </a>

  <!-- Rechts: Glocke + Name + Avatar -->
  <div class="header-right">

    <!-- Benachrichtigungs-Glocke -->
    <button class="header-bell" (click)="togglePanel()" aria-label="Benachrichtigungen">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
      @if (notif.unreadCount() > 0) {
        <span class="bell-badge">{{ notif.unreadCount() > 9 ? '9+' : notif.unreadCount() }}</span>
      }
    </button>

    <!-- Name + Avatar → Profil -->
    <a routerLink="/profil" class="header-profile">
      <span class="header-displayname">{{ auth.user()?.username }}</span>
      @if (auth.user()?.profile_image) {
        <img class="header-avatar" [src]="auth.user()!.profile_image!" alt="Profilbild" />
      } @else {
        <span class="header-avatar header-avatar--initials">{{ initials }}</span>
      }
    </a>
  </div>

</header>

<!-- Benachrichtigungs-Panel: Dropdown unter der Glocke.
     Bewusst AUSSERHALB von <header> (eigener Stacking-Context), damit es
     über der Fußnavigation liegt und nicht abgeschnitten wird. -->
@if (showPanel()) {
  <div class="notif-backdrop" (click)="showPanel.set(false)"></div>
  <div class="notif-dropdown">

    <div class="notif-head">
      <h3 class="notif-head-title">Benachrichtigungen</h3>
      @if (notif.unreadCount() > 0) {
        <button class="notif-readall" (click)="notif.markAllRead()">Alle gelesen</button>
      }
    </div>

    @if (notif.notifications().length === 0) {
      <p class="notif-empty">Keine neuen Benachrichtigungen.</p>
    } @else {
      <div class="notif-list">
        @for (n of notif.notifications(); track n.id) {
          <button class="notif-item" (click)="openItem(n)">
            <span class="notif-ic" [style.color]="catColor(n.category)" [style.background]="catBg(n.category)">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path [attr.d]="catIcon(n.category)"/>
              </svg>
            </span>
            <span class="notif-text">
              <span class="notif-title">{{ n.title }}</span>
              @if (n.body) { <span class="notif-body">{{ n.body }}</span> }
              <span class="notif-time">{{ formatTime(n.created_at) }}</span>
            </span>
          </button>
        }
      </div>
    }

    <a routerLink="/einstellungen/benachrichtigungen" class="notif-manage" (click)="showPanel.set(false)">
      <span>Benachrichtigungen verwalten</span>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M9 5l7 7-7 7"/></svg>
    </a>
  </div>
}
